
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rag-development-services",
      function () {
        return require("private-next-pages/rag-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rag-development-services"])
      });
    }
  